import { render, staticRenderFns } from "./input-checkbox.vue?vue&type=template&id=566105b0&"
import script from "./input-checkbox.vue?vue&type=script&lang=js&"
export * from "./input-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports